import { render, staticRenderFns } from "./TaskChangeDates.vue?vue&type=template&id=33bf67fc&scoped=true&lang=pug&"
import script from "./TaskChangeDates.vue?vue&type=script&lang=js&"
export * from "./TaskChangeDates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bf67fc",
  null
  
)

export default component.exports